import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'


export class OpSimCardData implements IOpData {
    //Properties
    public idSimCardData: number
    public idSimCard: number
    public idDataType: number
    public indexNbr: number
    public value: any
    //Properties end

    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end
    
    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IOpData implementation
    public get idData() { return this.idSimCardData }
    public set idData(idData: number) { this.idSimCardData = idData }
    //get idDataType() { return this.idDataType }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }
    //get value() { return this.value }
    //IOpData implementation end

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idSimCardData = opObj.ID_SIM_CARD_DATA
            this.idSimCard = opObj.ID_SIM_CARD
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            this.dataType = opObj._DataType
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_SIM_CARD_DATA: this.idSimCardData,
            ID_SIM_CARD: this.idSimCard,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpSimCardData {
        var newData: OpSimCardData = new OpSimCardData(null)
        newData.idSimCardData = data.idData,
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState
        return newData
    }

}